import React from 'react';
import { scoreCriteria } from '../../data/methodology';
export function MethodologySection() {
  return <section id="methode" aria-labelledby="methode-title" className="mx-auto max-w-7xl scroll-mt-28 px-4 sm:px-6" data-id="element-136" data-mp="1pthyz3x7sgwn">
      <div className="grid gap-10 border-t border-line pt-16 lg:grid-cols-[1fr_1.4fr] lg:gap-16" data-id="element-137" data-mp="23r6j29jgjk0n">
        <div data-id="element-138" data-mp="1yuprt6gyopjc">
          <h2 id="methode-title" className="font-serif text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-139" data-mp="1yu7o5oryz91e">
            Hoe de SlotGids Score werkt
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-140" data-mp="165ilhlb9mvnj">
            We combineren wat Kiwi’s spelen met wat Nederlandstalige spelers zoeken, en testen elke slot zelf op
            gameplay en mobiel. Casino’s kunnen geen plek in de Top 30 kopen.
          </p>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-141" data-mp="1g13uw4inyy7b">
            De ranglijst wordt elke maand herzien. Daalt een slot in populariteit of verschijnt er een sterkere
            opvolger, dan passen we de volgorde aan.
          </p>
        </div>
        <ul className="space-y-5" data-id="element-142" data-mp="se1tezyokrjn">
          {scoreCriteria.map(c => <li key={c.label} className="grid grid-cols-[minmax(0,1fr)_48px] items-start gap-x-4" data-id="element-143" data-mp="xdo71aif89sz">
              <div data-id="element-144" data-mp="124egozxvqyth">
                <p className="font-semibold" data-id="element-145" data-mp="125zcesvxknsx">{c.label}</p>
                <p className="text-sm text-muted" data-id="element-146" data-mp="166i0qcym7bqd">{c.description}</p>
                <div className="mt-2 h-1.5 rounded-full bg-line" aria-hidden="true" data-id="element-147" data-mp="165qa7gjvk46y">
                  <div className="h-full rounded-full bg-fern" style={{
                width: `${c.weight / 30 * 100}%`
              }} data-id="element-148" data-mp="9htpbzhemmpx" />
                </div>
              </div>
              <span className="text-right font-serif text-xl font-semibold tabular-nums" data-id="element-149" data-mp="ih71x10trrev">{c.weight}%</span>
            </li>)}
        </ul>
      </div>
    </section>;
}